<template>
  <div :class="['flex items-center', layout]">
    <div
      :class="[
        'flex items-center justify-center md:min-h-136 md:ml-12 md:mr-12 rounded-motif my-5 bg-white overflow-hidden',
        wrapper,
        imageShadow ? 'shadow-md' : ''
      ]"
    >
      <Loading
        v-if="loading"
        class="w-64 max-w-9/10 md:w-128 h-64 flex items-center justify-center"
      />
      <img
        v-show="!loading"
        v-bind="disalbeCopy"
        :src="webpImageUrl"
        :class="['cursor-pointer', imageStyle]"
        @load="handleLoad"
        @click="handleClick"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import Loading from '../../../resources-loading';
import { webpImage } from '@forchange/cleword-utils';
import { ImageContent } from '@/store/modules/image/types';

@Component({
  components: {
    Loading
  }
})
export default class ImageBlock extends Vue {
  @Prop({ type: Object }) content!: Content & {
    url: string;
    align: string;
    size: number;
    biggerMaxWidth: string;
    shadow?: 'hidden' | '隐藏';
  };

  loading = true;

  get layout() {
    const layout: Array<String> = [];
    // position
    switch (this.content.align) {
      case '居中':
      case 'center':
        layout.push('justify-center');
        break;
      case '居右':
      case 'right':
        layout.push('justify-end');
        break;
      default:
        layout.push('justify-start');
        break;
    }
    return layout.join(' ');
  }

  get webpImageUrl() {
    return webpImage(this.content.url);
  }

  get wrapper() {
    const size: Array<String> = [];

    // max-width
    size.push(
      this.content.size || ['是', true].includes(this.content.biggerMaxWidth)
        ? 'lg:max-w-9/10'
        : 'md:max-w-600'
    );
    return size.join(' ');
  }

  get imageStyle() {
    const size: Array<String> = [];
    const fontSize = ['', 'w-64', 'w-96', 'w-128', 'w-200', 'w-240', 'w-280', 'w-320'];
    // custom width
    size.push(fontSize[this.content.size] || '');
    return size.join(' ');
  }

  get imageShadow() {
    return !['hidden', '隐藏'].includes(this.content.shadow || '');
  }

  get disalbeCopy() {
    if (this.$store.state.common.disalbeCopy) {
      return {
        style:
          'user-select: none;-webkit-user-drag: none;-webkit-user-select: none;-webkit-touch-callout: none;',
        oncontextmenu: 'return false;'
      };
    }
    return {};
  }

  handleClick() {
    const images = this.$store.state.images.images as Array<ImageContent>;
    const index = images.findIndex((image) => image.$id === this.content.$id);
    window.$imageViewer?.lightbox.loadAndOpen(index);
  }

  handleLoad() {
    this.loading = false;
    this.$emit('loaded');
  }
}
</script>
